import { Component, OnInit } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { ApplicationLogService, LazyLoadingResponse, LogEntryResponse } from 'src/app/Services/applicationlogs.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';

@Component({
    selector: 'app-application-log',
    templateUrl: './application-log.component.html',
    providers: [AuthService, ApplicationLogService],
    standalone: false
})
export class ApplicationLogComponent implements OnInit {

    public logs: LogEntryResponse[] = [];
    public authConfig: AuthConfig = {};
    public rows: number = 20;
    public lazyLogs: LogEntryResponse[] = [];
    public totalRecords!: number;
    public loading: boolean = false;
    
    constructor(
        private authService: AuthService,
        private applicationLogService: ApplicationLogService
    ) { }

    public ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
            this.getLazyApplicationLogs({ first: 0, rows: this.rows, sortField: '1' });
        }
    }

    public getRowStyle(log: LogEntryResponse): string {
        if (log.Level === 'Error') {
            return 'text-danger';
        }
        return ''; // No additional styling for other log levels
    }

    public getLazyApplicationLogs($event:TableLazyLoadEvent){
        this.loading = true;
        $event.sortField = "1";
        this.applicationLogService.getApplicationLogs($event).subscribe((logs: LazyLoadingResponse<LogEntryResponse>) => {
            this.logs = logs.data!;
            this.totalRecords = logs.totalRecords;
            console.log(this.logs); // Logging fetched logs
            this.loading = false;
        }, (error) => { console.error('Error fetching Application logs:', error); this.loading = false; });
    }
}
